import { Box, Paper, Typography } from '@mui/material';

export function SettingsPage() {
  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ p: { xs: 3, md: 4 }, borderRadius: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 800 }}>
          Under development
        </Typography>
      </Paper>
    </Box>
  );
}

